
import { timeFix, toMoney } from '@/utils/validate'
import { mapGetters } from 'vuex'
import { copyToClip } from '~/utils/index'
import ArrowRight from '../PZIcons/ArrowRight.vue'
import Edit from '../PZIcons/Edit.vue'
import Copy from '../PZIcons/Copy.vue'

const SellGoodsTypeModel = () => import('@/components/CSS/SellGoodsTypeModel')
export default {
	components: {
		ArrowRight,
		Edit,
		Copy,
		SellGoodsTypeModel
	},
	computed: {
		...mapGetters({
			userinfo: 'user/userinfo',
			defaultAvatar: 'user/defaultAvatar',
			userAccount: 'user/userAccount'
		}),
		timeFixText() {
			return timeFix()
		},
		infoCounts() {
			return [
				{
					label: '我的咨询',
					count: this.userAccount?.consultNumber || 0,
					to: '/account/consultList'
				},
				// {
				// 	label: '我的商品',
				// 	count: this.userAccount?.goodsNumber || 0,
				// 	to: '/account/sellerList'
				// },
				{
					label: '我的收藏',
					count: this.userAccount?.collectionNumber || 0,
					to: '/account/collection'
				},
				{
					label: '提现',
					prefix: '￥',
					count: toMoney(this.userAccount?.balanceAmount || 0),
					to: '/account/tiXian'
				}
			]
		}
	},
	props: {
		buyType: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			discountTypes: ['有降价', '限时秒杀', '限时优惠'],
			certification: 'https://oss.pzds.com/imgv2/certification.png',
			unCertification: 'https://oss.pzds.com/imgv2/unCertification.png',
			realNameModelState: false,
			discountMessageTimer: null
		}
	},
	methods: {
		handleAuthRealName() {
			this.realNameModelState = true
		},
		toMoneyPrice(num) {
			return toMoney(num)
		},
		handleCopyId(id) {
			copyToClip(id, '已复制')
		},
		buy() {
			this.$nextTick(async () => {
				if (this.userinfo) {
					await this.$store.dispatch('user/UserGetInfo')
					if (!this.userinfo.isRealName) {
						this.handleAuthRealName()
						return
					}
				}
				this.$router.push(`/selectGame`)
				window._czc && window._czc.push(['_trackEvent', '访问量', '我要卖页面'])
			})
		},
		handleDiscountClick(label, tagClick) {
			if (label === '我的收藏') {
				this.$store.dispatch('user/unreadMessageCollection')
				if (this.discountMessageTimer) {
					clearTimeout(this.discountMessageTimer)
					this.discountMessageTimer = null
				}
				if (tagClick) {
					const type = this.userAccount?.discountType || 0
					this.$router.push({ path: '/account/collection?tagType=' + type })
				}
			}
		},
	},
	mounted() {
		console.log('this.userinfo', this.userinfo)
		if (this.userAccount?.discountType) {
			this.discountMessageTimer = setTimeout(() => {
				this.$store.dispatch('user/unreadMessageCollection')
			}, 10000)
		}
	},
	beforeDestroy() {
		if (this.discountMessageTimer) {
			clearTimeout(this.discountMessageTimer)
			this.discountMessageTimer = null
		}
	}
}
